import { useNavigate } from 'react-router-dom';
import useStore from '../Hooks/useStore';
import './Header.css';
import * as S from './Style';
import Select from '../Select';
import LogoGrey from '../../images/Group 7.png';
import VoltarGrey from '../../images/voltarGrey22x20.png';
import sinoGrey from '../../images/sino.png';

import conatGrey from '../../images/conta.png';
import configuracaoGrey from '../../images/configuracao.png';
export default function Header() {
  const [getters, setters] = useStore();
  const navigate = useNavigate();

  const {
    user: { getUser, getCurrentUser, getSelectedFilial },
  } = getters;

  const {
    user: { selectFilial },
  } = setters;
  const userName = getCurrentUser().name.split('.')[0];
  const filials = getUser('current_user.filials');
  const selectedFilial = getSelectedFilial();

  const filialItems = filials.map(({ id, fantasyName }) => ({
    id,
    name: fantasyName,
  }));
  const hasManyFilials = filialItems.length > 1;

  const handleSelectFilial = (item) => {
    selectFilial(item.id);
  };

  return (
    <div style={{ position: 'relative'}}>
      <nav className="header">
        <div
          style={{
            display: 'flex',
          }}
        >
          <S.LogoHeaderGrey
            src={LogoGrey}
            onClick={() => navigate('/')}
          />
          <S.VoltarHeaderGrey src={VoltarGrey} onClick={() => navigate(-1)} />
        </div>
        <div
          style={{
            display: 'flex',
          }}
        >
          {hasManyFilials ? (
            <Select
              value={selectedFilial.fantasyName}
              label={selectedFilial.fantasyName}
              items={filialItems}
              onSelected={handleSelectFilial}
            />
          ) : null}
          <S.UsuarioSpan>
            {hasManyFilials ? (
              <>{`${userName}`}</>
            ) : (
              `${selectedFilial.fantasyName} - ${userName}`
            )}
          </S.UsuarioSpan>

          <S.Boxul>
            <S.SinoHeaderGrey src={sinoGrey} />
            <S.ContaHeaderGrey src={conatGrey} />
            <S.ConfiguracaoHeaderGrey
              src={configuracaoGrey}
              onClick={() =>
                navigate(`/tools/banner/configurations`)
              }
            />
          </S.Boxul>
        </div>
      </nav>
      <label
        style={{
          position: 'absolute',
          color: 'white',
          fontSize: '14px',
          right: '1rem',
          marginTop: '0.5rem',
          fontWeight: 'bold',
        }}
      >
        Versão 1.0.1
      </label>
    </div>
  );
}
